import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { FarmerInsightsEffects } from './store/effects/farmer-insights.effects';
import { reducer } from './store/reducers/farmer-insights.reducer';

export function provideFarmerInsightsFeature() {
  return makeEnvironmentProviders([
    provideState('farmerInsightsModule', reducer),
    provideEffects(FarmerInsightsEffects),
  ]);
}
